// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"BlogCard_cardTitle__1DT0q","cardContent":"BlogCard_cardContent__3U8ma","tags":"BlogCard_tags__2NSMz"};